import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { CertificationsFragmentGql } from './DataQualityCertificationFragmentsGql';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const VirtualConnectionsDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment VirtualConnectionsDisplayGridRowDataFragment on VirtualConnection {
  __typename
  id
  luid
  vizportalUrlId
  name
  owner {
    name
    username
    domain
  }
  tablesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  isCertified
  ...CertificationsFragment
  dataQualityWarnings {
    ...DataQualityWarningFragment
    ...DataQualityWarningAssetFragment
  }
  containerName
  containerType
  projectVizportalUrlId
}
${CertificationsFragmentGql}
${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
`;
